module.exports = __webpack_public_path__ + "assets/assignment-topic-inactive.1bb70ce8.svg";